import { toast } from "react-toastify";

export const getApiLanguage = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const resolveFallbackMessage = (fallbackMessage) => {
  if (!fallbackMessage) return "";
  if (typeof fallbackMessage === "string") return fallbackMessage;
  if (typeof fallbackMessage === "object") {
    const lang = getApiLanguage();
    return fallbackMessage[lang] || fallbackMessage.en || fallbackMessage.ar || "";
  }
  return "";
};

const extractApiMessage = (source) => {
  if (!source) return null;

  if (source?.response?.data !== undefined) {
    const { data } = source.response;
    return data?.message ?? data;
  }

  if (source?.data?.message !== undefined) {
    return source.data.message;
  }

  if (source?.message !== undefined) {
    return source.message;
  }

  return source;
};

/**
 * Returns a localized string from an API response/error message object.
 * Supports `{ en, ar }`, plain strings, axios responses, and rejectWithValue payloads.
 */
export const getLocalizedApiMessage = (source, fallbackMessage = "") => {
  if (typeof source === "string" && source.trim()) {
    return source;
  }

  const message = extractApiMessage(source);
  const fallback = resolveFallbackMessage(fallbackMessage);

  if (message && typeof message === "object") {
    const lang = getApiLanguage();
    return message[lang] || message.en || message.ar || fallback;
  }

  if (typeof message === "string" && message.trim()) {
    return message;
  }

  return fallback;
};

export const showApiSuccessToast = (
  source,
  fallbackMessage = "",
  options = {},
) => {
  const text = getLocalizedApiMessage(source, fallbackMessage);
  if (text) {
    toast.success(text, options);
  }
};

export const showApiErrorToast = (source, fallbackMessage = "", options = {}) => {
  const text = getLocalizedApiMessage(source, fallbackMessage);
  if (text) {
    toast.error(text, options);
  }
};
